<!--体检报告-->

<template>
  <div class="PhysicalExamination">
    <div class="header">
      <div class="header-empname">{{ pageConfig.emp_name }}</div>
    </div>
    <van-cell-group>
      <van-cell
        v-for="item in pageConfig.reportList"
        :key="item.id"
        is-link
        value="预览"
        :title="item.examination_year + '员工体检报告'"
        @click="methods.previewReport(item.attachment_id)"
      />
    </van-cell-group>
    <van-empty v-if="pageConfig.reportList.length == 0" description="未找到体检报告"></van-empty>
    
  </div>
</template>

<script>
import { CallIPaasService } from '@/api/mobile.js'
import { reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const router = useRouter()
    //配置参数
    const pageConfig = reactive({
      reportList: [], //报告列表
      emp_name:
        localStorage.getItem('emp_code') +
        '-' +
        localStorage.getItem('emp_name'),
    })
    //内置函数
    const methods = {
      //获取体检报告
      getEmpPhysicalExamination: function () {
        CallIPaasService(
          { empId: localStorage.getItem('emp_id') },
          'emp1010'
        ).then((res) => {
          if (res.code == 200) {
            pageConfig.reportList = res.data
          }
        })
      },
      //预览体检报告
      previewReport: function (attachment_id) {
        router.push({ name: 'SpacePreview', query: { id: attachment_id } })
      }
    }
    onMounted(() => {
      //获取体检报告
      methods.getEmpPhysicalExamination()
    })
    return {
      pageConfig,
      methods,
    }
  },
}
</script>
<style scoped lang="scss">
.PhysicalExamination {
  .header {
    .header-empname {
      background-color: #fff;
      font-size: 12px;
      line-height: 30px;
      text-align: center;
    }
  }
}
</style>
